import { get, post } from "@/utils/request";

// 测试数据调试
export function getProductList(params = {}) {
  return post("/shopping-cart/page", params);
}
//获取基本信息（如列表顶部图片，登录页左侧图片等）
export function shopConfigGetData(params = {}) {
  return get("/shop-config/get-data", params);
}
//获取登录用户基本信息
export function getUserInfo(params = {}) {
  return get("/member/get-user-info", params);
}
// 会员类别管理接口
export function categoryPage(params = {}) {
  return post("/member-category/page", params);
}
// 五大认证
// 内部员工认证
export function verifiedStaff(params = {}) {
  return post("/member/verified-staff", params);
}
// 代理商认证
export function verifiedAgent(params = {}) {
  return post("/member/verified-agent", params);
}
// 终端医院认证
export function verifiedHospital(params = {}) {
  return post("/member/verified-hospital", params);
}
// 合伙人认证
export function verifiedPartner(params = {}) {
  return post("/member/verified-partner", params);
}
// 供应商认证
export function verifiedSupplier(params = {}) {
  return post("/member/verified-supplier", params);
}
// 个人认证
export function verifiedPersonal(params = {}) {
  return post("/member/verified-person", params);
}
//01 我的邀请
export function memberInvite(params = {}) {
  return post("/invitations/page", params);
}
// 获取邀请码
export function Invitecode(params = {}) {
  return post("/invitations/get-code", params);
}
//02 收货地址
export function shippingAddressList(params = {}) {
  return post("/shipping-address/page-list", params);
}
// 收货地址----根据Id查询数据
export function queryAddressList(params = {}) {
  return get(`/shipping-address/findById/${params.id}`, params);
}
// 收货地址----删除数据
export function deleteAddressList(params = {}) {
  return post("/shipping-address/delete-by-id", params);
}
// 收货地址----保存数据
export function saveAddressList(params = {}) {
  return post("/shipping-address/save", params);
}
// 收货地址----设置为默认
export function savedefault(params = {}) {
  return post("/shipping-address/set-default", params);
}
//03 我的收藏
// 我的收藏----获取数据列表
export function favoritesList(params = {}) {
  return post("/favorites/page-list", params);
}
// 我的收藏----添加收藏
export function favoritesAdd(params = {}) {
  return post("/favorites/add", params);
}
// 我的收藏----删除收藏
export function deleteFavorites(params = { params }) {
  return post("/favorites/delete-favorites", params);
}
// 我的收藏----批量删除
export function deletebatch(params = { params }) {
  return post("/favorites/delete-favorites-batch", params);
}
// 我的收藏----根据产品Id查询收藏状态
export function FavoritesId(params = {}) {
  return post("/favorites/find-by-product-id", params);
}
// 我的收藏----加入购物车
export function FavoritesAddcart(params = {}) {
  return post("/shopping-cart/add-cart", params);
}

//团队管理接口
// 获取数据列表
export function teampagelist(params = {}) {
  return post("/member-team/page-list", params);
}
// 添加子账户
export function teamaddmember(params = {}) {
  return post("/member-team/add-member", params);
}
// 修改状态
export function teamupdatestatus(params = {}) {
  return post("/member-team/update-status", params);
}
// 根据Id查询数据
export function teamfindById(params = {}) {
  return get(`/member-team/findById/${params.id}`, params);
}
// 修改为发布状态
export function teamupdatepublish(params = {}) {
  return post("/member-team/update/status/publish", params);
}
// 修改为草稿状态
export function teamdraft(params = {}) {
  return post("/member-team/update/status/draft", params);
}
// 根据姓名查询会员列表
export function memberpagelist(params = {}) {
  return post("/member/page-list", params);
}

// 我的团队接口----获取数据列表
export function memberTeamPageList(params = {}) {
  return post("/member-team/page-list", params);
}
// 订单管理接口----申请或修改开票信息
export function orderupdateinvoice(params = {}) {
  return post("/order/update-invoice", params);
}
// 协议管理接口----获取数据列表
export function agreementManagePageList(params = {}) {
  return post("/agreement-manage/page-list", params);
}

// 订单管理接口----订单可用协议
export function orderCheckOrder(params = {}) {
  return post("/order/check-order", params);
}

// 协议管理接口----根据Id查询数据
export function agreementmanagefindById(params = {}) {
  return get(`/agreement-manage/findById/${params.id}`, params);
}

// 协议管理接口----协议商品管理接口
export function agreementproductpagelist(params = {}) {
  return post("/agreement-product/page-list", params);
}

// 协议管理接口----根据Id查询数据
// export function agreementmanagefindById(params = {}) {
//   return get(`/agreement-manage/findById/${params.id}`, params);
// }

// 协议管理接口----获取单次合同
export function singleContractGetData(params = {}) {
  return get("/single-contract/get-data", params);
}

// 协议管理接口----根据医院获取仪器列表
export function instrumentListByHospitalName(params = {}) {
  return post("/member/instrument-list-by-hospital-name", params);
}

// 如果是单次合同查询官网里终端用户
export function shopApiHospitalList(params = {}) {
  return get("/shop-api/hospital-list", params);
}

// 协议商品管理接口----获取快速订购数据
export function agreementProductPage(params = {}) {
  return post("/agreement-product/page-list", params);
}

// 售后接口----获取订单列表
export function orderPageList(params = {}) {
  return post("/order/page-list", params);
}

// 售后接口----取消售后
export function orderCancelAfterSale(params = {}) {
  return post("/order/cancel-after-sale", params);
}

// 售后接口----申请售后
export function orderSubmitAfterSale(params = {}) {
  return post("/order/submit-after-sale", params);
}

// 售后接口----获取售后申请原因列表
export function afterSaleApplyReasonPage(params = {}) {
  return post("/after-sale-apply-reason/page", params);
}

// 售后接口----获取售后申请类型列表
export function afterSaleApplyTypePage(params = {}) {
  return post("/after-sale-apply-type/page", params);
}

// 售后接口----签收订单
export function orderSigningOrder(params = {}) {
  return post("/order/signing-order", params);
}
